import * as i0 from '@angular/core';
import { inject, ElementRef, ViewContainerRef, Directive, Input, Injectable, Renderer2, NgZone, DestroyRef, signal, ChangeDetectorRef, EventEmitter, computed, Component, ChangeDetectionStrategy, ViewChild, Output } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import * as i2 from '@taiga-ui/cdk';
import { TUI_RANGE, TUI_TRUE_HANDLER, tuiIsTextNode, tuiIsString, tuiIsElement, EMPTY_CLIENT_RECT, TuiPortalService, TuiControl, tuiInjectElement, TUI_FALSE_HANDLER, tuiWatch, tuiZonefree, tuiAutoFocusOptionsProvider, TuiActiveZone, TuiPortals } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core';
import { TuiDriver, TUI_SELECTION_STREAM, tuiGetWordRange, tuiAsDriver, tuiAsRectAccessor, tuiAppearanceFocus, tuiAppearanceMode, tuiAppearanceState, TUI_APPEARANCE_OPTIONS, tuiScrollbarOptionsProvider, TUI_ANIMATIONS_DEFAULT_DURATION, TuiScrollbar, TuiDropdown, TuiAppearance, TuiRectAccessor, TuiDropdownService, tuiAsViewport } from '@taiga-ui/core';
import { BehaviorSubject, combineLatest, map, distinctUntilChanged, ReplaySubject, take, shareReplay, delay, merge, fromEvent, throttleTime } from 'rxjs';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { LAZY_EDITOR_EXTENSIONS, TUI_EDITOR_EXTENSIONS, INITIALIZATION_TIPTAP_CONTAINER, TIPTAP_EDITOR, LAZY_TIPTAP_EDITOR, TUI_EDITOR_OPTIONS, TUI_EDITOR_VALUE_TRANSFORMER, TUI_EDITOR_RESIZE_EVENT } from '@taiga-ui/editor/common';
import { TuiEditLink } from '@taiga-ui/editor/components/edit-link';
import { TuiEditorSocket } from '@taiga-ui/editor/components/editor-socket';
import { TuiToolbar } from '@taiga-ui/editor/components/toolbar';
import { TuiTiptapEditorService, TuiTiptapEditor } from '@taiga-ui/editor/directives';
import { tuiGetSelectionState, tuiIsSafeLinkRange } from '@taiga-ui/editor/utils';
const _c0 = ["tuiDropdown"];
const _c1 = ["*", [["tools"]], [["mention"]]];
const _c2 = ["*", "tools", "mention"];
function TuiEditor_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const toolbarTpl_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", toolbarTpl_r2);
  }
}
function TuiEditor_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("mousedown", function TuiEditor_div_0_div_5_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focus($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.placeholder || ctx_r2.exampleText, " ");
  }
}
function TuiEditor_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtemplate(2, TuiEditor_div_0_ng_container_2_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵlistener("mousedown", function TuiEditor_div_0_Template_div_mousedown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focus($event));
    });
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TuiEditor_div_0_div_5_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "tui-scrollbar", 12);
    i0.ɵɵlistener("keydown", function TuiEditor_div_0_Template_tui_scrollbar_keydown_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focus($event));
    })("mousedown", function TuiEditor_div_0_Template_tui_scrollbar_mousedown_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focus($event));
    });
    i0.ɵɵelementContainer(7, 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const editorTpl_r5 = i0.ɵɵreference(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.floatingToolbar);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.hasPlaceholder);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", editorTpl_r5);
  }
}
function TuiEditor_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-toolbar", 15);
    i0.ɵɵlistener("fileAttached", function TuiEditor_ng_template_2_Template_tui_toolbar_fileAttached_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.fileAttached.emit($event));
    });
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r2.interactive())("tools", ctx_r2.tools);
  }
}
function TuiEditor_ng_template_4_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const toolbarTpl_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", toolbarTpl_r2);
  }
}
function TuiEditor_ng_template_4_ng_template_3_tui_edit_link_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-edit-link", 19, 4);
    i0.ɵɵlistener("addLink", function TuiEditor_ng_template_4_ng_template_3_tui_edit_link_2_Template_tui_edit_link_addLink_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const link_r9 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      link_r9.anchorMode ? ctx_r2.addAnchor($event) : ctx_r2.addLink($event);
      return i0.ɵɵresetView(ctx_r2.closeDropdown());
    })("removeLink", function TuiEditor_ng_template_4_ng_template_3_tui_edit_link_2_Template_tui_edit_link_removeLink_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const link_r9 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      link_r9.anchorMode ? ctx_r2.removeAnchor() : ctx_r2.removeLink();
      return i0.ɵɵresetView(ctx_r2.closeDropdown());
    });
    i0.ɵɵelementEnd();
  }
}
function TuiEditor_ng_template_4_ng_template_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementContainerEnd();
  }
}
function TuiEditor_ng_template_4_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, TuiEditor_ng_template_4_ng_template_3_ng_container_1_Template, 2, 1, "ng-container", 9)(2, TuiEditor_ng_template_4_ng_template_3_tui_edit_link_2_Template, 2, 0, "tui-edit-link", 18)(3, TuiEditor_ng_template_4_ng_template_3_ng_container_3_Template, 2, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("t-floating", ctx_r2.floatingToolbar);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.floatingToolbar);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isLinkSelected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isMentionMode);
  }
}
function TuiEditor_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16, 2)(2, "div", 17);
    i0.ɵɵlistener("valueChange", function TuiEditor_ng_template_4_Template_div_valueChange_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onModelChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, TuiEditor_ng_template_4_ng_template_3_Template, 4, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const dropdown_r10 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tuiDropdown", dropdown_r10)("tuiToolbarDropdown", ctx_r2.dropdownSelectionHandler)("tuiToolbarDropdownPosition", ctx_r2.floatingToolbar ? "selection" : "tag");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("editable", ctx_r2.interactive());
  }
}
let TuiEditorDropdownToolbar = /*#__PURE__*/(() => {
  class TuiEditorDropdownToolbar extends TuiDriver {
    constructor() {
      super(subscriber => this.stream$.subscribe(subscriber));
      this.previousTagPosition = null;
      this.range = inject(TUI_RANGE);
      this.doc = inject(WA_WINDOW)?.document ?? null;
      this.selection$ = inject(TUI_SELECTION_STREAM);
      this.el = inject(ElementRef);
      this.vcr = inject(ViewContainerRef);
      this.handler$ = new BehaviorSubject(TUI_TRUE_HANDLER);
      this.stream$ = combineLatest([this.handler$, this.selection$.pipe(map(() => this.getRange()), distinctUntilChanged((x, y) => x.startOffset === y.startOffset && x.endOffset === y.endOffset))]).pipe(map(([handler, range]) => {
        const contained = this.el.nativeElement.contains(range.commonAncestorContainer) || range.commonAncestorContainer.parentElement?.closest('tui-dropdown');
        this.range = contained && tuiIsTextNode(range.commonAncestorContainer) || range.commonAncestorContainer?.nodeName === 'P' ? range : this.range;
        return contained && handler(this.range);
      }));
      this.position = 'selection';
      this.type = 'dropdown';
    }
    set tuiToolbarDropdown(visible) {
      if (!tuiIsString(visible)) {
        this.handler$.next(visible);
      }
    }
    getClientRect() {
      switch (this.position) {
        case 'tag':
          {
            const {
              commonAncestorContainer
            } = this.range;
            const element = tuiIsElement(commonAncestorContainer) ? commonAncestorContainer : commonAncestorContainer.parentNode;
            if (element?.parentElement?.closest('tui-dropdown')) {
              return this.previousTagPosition ?? EMPTY_CLIENT_RECT;
            }
            this.previousTagPosition = element && tuiIsElement(element) ? this.doc?.querySelector('.ProseMirror-selectednode')?.getBoundingClientRect() || element.getBoundingClientRect() : EMPTY_CLIENT_RECT;
            return this.previousTagPosition;
          }
        case 'word':
          return tuiGetWordRange(this.range).getBoundingClientRect();
        default:
          {
            const rect = this.range.getBoundingClientRect();
            if (rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0) {
              return (this.el.nativeElement.querySelector('p') ?? this.el.nativeElement).getBoundingClientRect();
            }
            return rect;
          }
      }
    }
    ngOnDestroy() {
      if (this.ghost) {
        this.vcr.element.nativeElement.removeChild(this.ghost);
      }
    }
    getRange() {
      const selection = this.doc?.getSelection();
      return (selection?.rangeCount && selection.getRangeAt(0) || this.range)?.cloneRange();
    }
    static {
      this.ɵfac = function TuiEditorDropdownToolbar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiEditorDropdownToolbar)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiEditorDropdownToolbar,
        selectors: [["", "tuiToolbarDropdown", ""]],
        inputs: {
          position: [0, "tuiToolbarDropdownPosition", "position"],
          tuiToolbarDropdown: "tuiToolbarDropdown"
        },
        features: [i0.ɵɵProvidersFeature([tuiAsDriver(TuiEditorDropdownToolbar), tuiAsRectAccessor(TuiEditorDropdownToolbar)]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiEditorDropdownToolbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiEditorPortalService = /*#__PURE__*/(() => {
  class TuiEditorPortalService extends TuiPortalService {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiEditorPortalService_BaseFactory;
        return function TuiEditorPortalService_Factory(__ngFactoryType__) {
          return (ɵTuiEditorPortalService_BaseFactory || (ɵTuiEditorPortalService_BaseFactory = i0.ɵɵgetInheritedFactory(TuiEditorPortalService)))(__ngFactoryType__ || TuiEditorPortalService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TuiEditorPortalService,
        factory: TuiEditorPortalService.ɵfac
      });
    }
  }
  return TuiEditorPortalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_EDITOR_PROVIDERS = [{
  provide: LAZY_EDITOR_EXTENSIONS,
  deps: [TUI_EDITOR_EXTENSIONS],
  useFactory: extensions => {
    const extensions$ = new ReplaySubject(1);
    Promise.all(extensions).then(extensions => extensions$.next(extensions)).catch(() => extensions$.next([]));
    return extensions$;
  }
}, {
  provide: INITIALIZATION_TIPTAP_CONTAINER,
  deps: [Renderer2],
  useFactory: renderer => renderer.createElement('div')
}, {
  provide: TIPTAP_EDITOR,
  deps: [INITIALIZATION_TIPTAP_CONTAINER, LAZY_EDITOR_EXTENSIONS, LAZY_TIPTAP_EDITOR, WA_WINDOW, TUI_EDITOR_OPTIONS],
  useFactory: (element, extensions, editor, winRef, options) => combineLatest([editor, extensions]).pipe(take(1), map(([Editor, extensions]) => {
    try {
      if (!globalThis.document) {
        globalThis.document = winRef.document;
      }
      return new Editor({
        ...options,
        element,
        extensions
      });
    } catch {
      return null;
    }
  }), shareReplay({
    bufferSize: 1,
    refCount: true
  }))
}, TuiTiptapEditorService, TuiEditorPortalService];
let TuiEditor = /*#__PURE__*/(() => {
  class TuiEditor extends TuiControl {
    constructor() {
      super(...arguments);
      this.rootEl = tuiInjectElement();
      this.contentProcessor = inject(TUI_EDITOR_VALUE_TRANSFORMER, {
        optional: true
      });
      this.doc = inject(WA_WINDOW)?.document ?? null;
      this.zone = inject(NgZone);
      this.destroy$ = inject(DestroyRef);
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.editorLoaded = signal(false);
      this.editorLoaded$ = inject(TIPTAP_EDITOR);
      this.cd = inject(ChangeDetectorRef);
      this.$ = this.editorLoaded$.pipe(delay(0), takeUntilDestroyed()).subscribe(() => {
        this.hasMentionPlugin = !!this.editorService.getOriginTiptapEditor()?.extensionManager.extensions.find(extension => extension.name === 'mention');
        this.editorService.setValue(this.firstInitialValue);
        this.editorLoaded.set(true);
        this.cd.detectChanges();
        // patch after rendered contenteditable element
        this.patchContentEditableElement();
        // listen resize events after any DOM changes
        this.listenResizeEvents();
      });
      /**
       * prevent recursive changes
       * between control and tiptap editor
       */
      this.firstInitialValue = '';
      /**
       * @deprecated use placeholder
       */
      this.exampleText = this.options.exampleText;
      this.placeholder = this.options.placeholder;
      this.floatingToolbar = this.options.floatingToolbar;
      this.tools = this.options.tools;
      this.fileAttached = new EventEmitter();
      this.focusIn = new EventEmitter();
      this.focusOut = new EventEmitter();
      this.hasMentionPlugin = false;
      this.hovered = toSignal(merge(fromEvent(tuiInjectElement(), 'mouseenter').pipe(map(TUI_TRUE_HANDLER)), fromEvent(tuiInjectElement(), 'mouseleave').pipe(map(TUI_FALSE_HANDLER))).pipe(tuiWatch(this.cdr)));
      this.focused = tuiAppearanceFocus(false);
      this.m = tuiAppearanceMode(this.mode);
      this.s = tuiAppearanceState(computed(() => {
        if (this.disabled()) {
          return 'disabled';
        }
        return this.hovered() ? 'hover' : null;
      }));
      this.editorService = inject(TuiTiptapEditorService);
      this.openDropdownWhen = range => this.currentFocusedNodeIsTextAnchor(range) || this.currentFocusedNodeIsImageAnchor || this.isMentionMode;
    }
    set readOnlyMode(value) {
      this.readOnly.set(value);
    }
    get editor() {
      return this.editorService.getOriginTiptapEditor() ? this.editorService : null;
    }
    get nativeFocusableElement() {
      return this.el?.nativeElement?.querySelector('[contenteditable].ProseMirror') || null;
    }
    get selectionState() {
      return tuiGetSelectionState(this.editor);
    }
    get mentionSuggestions() {
      const before = this.selectionState.before;
      return before?.startsWith('@') && before.length > 1 ? before?.replace('@', '') || '' : '';
    }
    get isMentionMode() {
      return this.hasMentionPlugin && this.selectionState.before?.startsWith('@');
    }
    writeValue(value) {
      const processed = this.contentProcessor?.fromControlValue(value) ?? value;
      super.writeValue(processed);
      if (this.firstInitialValue !== processed) {
        this.firstInitialValue = processed ?? '';
      }
      if (this.editorLoaded()) {
        this.editorService.setValue(processed ?? '');
      }
    }
    ngOnDestroy() {
      this.editor?.destroy();
    }
    get dropdownSelectionHandler() {
      if (!this.focused() || this.readOnly()) {
        return TUI_FALSE_HANDLER;
      }
      return this.floatingToolbar ? range => this.value().trim() !== '' && !this.editor?.state?.selection.empty || this.openDropdownWhen(range) : this.openDropdownWhen;
    }
    get hasPlaceholder() {
      return !!(this.placeholder || this.exampleText) && !this.value() && !this.readOnly();
    }
    get isLinkSelected() {
      const focusElement = this.doc?.getSelection()?.focusNode;
      const parentFocusElement = focusElement?.parentNode;
      return parentFocusElement?.nodeName.toLowerCase() === 'a' || parentFocusElement?.parentNode?.nodeName.toLowerCase() === 'a' || focusElement?.nodeName.toLowerCase() === 'a' || !!focusElement?.parentElement?.closest('a') || !!focusElement?.parentElement?.closest('tui-edit-link') || !!focusElement?.parentElement?.closest('tui-dropdown');
    }
    onModelChange(value) {
      const processed = this.contentProcessor?.toControlValue(value) ?? value;
      if (processed !== this.control.value) {
        this.onChange(processed ?? '');
        this.cd.detectChanges();
      }
    }
    onActiveZone(focused) {
      this.focused.set(focused);
      if (focused) {
        this.focusIn.emit();
      } else {
        this.focusOut.emit();
      }
    }
    addAnchor(anchor) {
      this.editor?.setAnchor(anchor);
    }
    removeAnchor() {
      this.editor?.removeAnchor();
    }
    closeDropdown() {
      this.tuiDropdown?.toggle(false);
    }
    addLink(link) {
      this.editor?.selectClosest();
      this.editor?.setLink(link);
    }
    removeLink() {
      this.editor?.unsetLink();
    }
    focus(event) {
      const isSafeArea = this.nativeFocusableElement?.contains(event.target) || Array.from(this.rootEl?.querySelectorAll('tui-toolbar') ?? []).some(toolbar => toolbar?.contains(event.target));
      if (isSafeArea) {
        return;
      }
      event.preventDefault();
      this.nativeFocusableElement?.focus();
    }
    get focusNode() {
      return this.doc?.getSelection?.()?.focusNode ?? null;
    }
    get currentFocusedNodeIsImageAnchor() {
      const node = this.focusNode?.childNodes[0]?.nodeName;
      return this.focusNode?.nodeName === 'A' && node && ['IMG', 'TUI-IMAGE-EDITOR'].includes(node) || false;
    }
    /**
     * @description:
     * The commonAncestorContainer not always relevant node element in Range,
     * so the focusNode is used for the correct behaviour from the selection,
     * which is the actual element at the moment
     */
    currentFocusedNodeIsTextAnchor(range) {
      return this.focusNode?.nodeName === 'A' || !!this.focusNode?.parentElement?.closest('tui-edit-link') || !!range.startContainer.parentElement?.closest('a') && tuiIsSafeLinkRange(range);
    }
    patchContentEditableElement() {
      this.nativeFocusableElement?.setAttribute('translate', this.options.translate);
      this.nativeFocusableElement?.setAttribute('spellcheck', String(this.options.spellcheck));
    }
    listenResizeEvents() {
      if (!this.el?.nativeElement) {
        return;
      }
      fromEvent(this.el.nativeElement, TUI_EDITOR_RESIZE_EVENT).pipe(throttleTime(0), tuiZonefree(this.zone), takeUntilDestroyed(this.destroy$)).subscribe(() => this.editorService.valueChange$.next(this.editorService.getHTML()));
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiEditor_BaseFactory;
        return function TuiEditor_Factory(__ngFactoryType__) {
          return (ɵTuiEditor_BaseFactory || (ɵTuiEditor_BaseFactory = i0.ɵɵgetInheritedFactory(TuiEditor)))(__ngFactoryType__ || TuiEditor);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiEditor,
        selectors: [["tui-editor"]],
        viewQuery: function TuiEditor_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TuiTiptapEditor, 5, ElementRef);
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tuiDropdown = _t.first);
          }
        },
        hostAttrs: ["ngSkipHydration", "true"],
        hostBindings: function TuiEditor_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("tuiActiveZoneChange", function TuiEditor_tuiActiveZoneChange_HostBindingHandler($event) {
              return ctx.onActiveZone($event);
            })("click", function TuiEditor_click_HostBindingHandler($event) {
              return ctx.focus($event);
            });
          }
        },
        inputs: {
          exampleText: "exampleText",
          placeholder: "placeholder",
          floatingToolbar: "floatingToolbar",
          tools: "tools",
          readOnlyMode: [0, "readOnly", "readOnlyMode"]
        },
        outputs: {
          fileAttached: "fileAttached",
          focusIn: "focusIn",
          focusOut: "focusOut"
        },
        features: [i0.ɵɵProvidersFeature([TUI_EDITOR_PROVIDERS, {
          provide: TUI_APPEARANCE_OPTIONS,
          useValue: {
            appearance: 'textfield'
          }
        }, tuiScrollbarOptionsProvider({
          mode: 'hover'
        }), tuiAutoFocusOptionsProvider({
          delay: TUI_ANIMATIONS_DEFAULT_DURATION,
          query: '[contenteditable].ProseMirror, input:not(.t-image, .t-file-upload), textarea, select'
        })]), i0.ɵɵHostDirectivesFeature([{
          directive: i1.TuiAppearance,
          inputs: ["tuiAppearance", "appearance"]
        }, {
          directive: i2.TuiActiveZone,
          outputs: ["tuiActiveZoneChange", "tuiActiveZoneChange"]
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 6,
        vars: 2,
        consts: [["toolbarTpl", ""], ["editorTpl", ""], ["tuiDropdown", "tuiDropdown"], ["dropdown", ""], ["link", ""], ["class", "t-wrapper", 4, "ngIf"], [1, "t-hidden-editor", 3, "content"], [1, "t-wrapper"], [1, "t-toolbar-wrapper"], [4, "ngIf"], [1, "t-editor-label", 3, "mousedown"], ["class", "t-editor-example-text", 3, "mousedown", 4, "ngIf"], [1, "t-scrollbar", 3, "keydown", "mousedown"], [3, "ngTemplateOutlet"], [1, "t-editor-example-text", 3, "mousedown"], [3, "fileAttached", "disabled", "tools"], ["tuiDropdownLimitWidth", "auto", 3, "tuiDropdown", "tuiToolbarDropdown", "tuiToolbarDropdownPosition"], ["tuiTiptapEditor", "", 1, "tui-editor-socket", 3, "valueChange", "editable"], [3, "addLink", "removeLink", 4, "ngIf"], [3, "addLink", "removeLink"]],
        template: function TuiEditor_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, TuiEditor_div_0_Template, 8, 3, "div", 5);
            i0.ɵɵelement(1, "tui-editor-socket", 6);
            i0.ɵɵtemplate(2, TuiEditor_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, TuiEditor_ng_template_4_Template, 5, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.editorLoaded());
            i0.ɵɵadvance();
            i0.ɵɵproperty("content", ctx.value());
          }
        },
        dependencies: [NgIf, NgTemplateOutlet, i1.TuiDropdownOptionsDirective, i1.TuiDropdownDirective, TuiEditLink, TuiEditorDropdownToolbar, TuiEditorSocket, TuiScrollbar, TuiTiptapEditor, TuiToolbar],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;isolation:isolate;font:var(--tui-font-text-m);border-radius:var(--tui-radius-m);max-block-size:inherit;min-block-size:10rem;box-sizing:border-box;overflow:auto}[_nghost-%COMP%]:after{content:\"\";display:table;clear:both}.t-wrapper[_ngcontent-%COMP%]{display:flex;block-size:100%;max-block-size:inherit;min-block-size:inherit;cursor:text;overflow:clip;flex-direction:column;border-radius:inherit}.t-editor-label[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;font:var(--tui-font-text-s);color:var(--tui-text-secondary);pointer-events:none;will-change:transform;transform:translateY(-.25rem);inline-size:95%;font-size:.9375rem}.t-editor-label_raised[_ngcontent-%COMP%]{transform:translateY(-.4375rem)}.t-editor-label[_ngcontent-%COMP%]:not(:empty){margin:1rem 1rem -.625rem;min-block-size:1.625rem}.t-editor-label[_ngcontent-%COMP%]:empty{margin-bottom:1rem}.t-editor-example-text[_ngcontent-%COMP%]{position:absolute;left:1rem;margin-top:.1875rem;color:var(--tui-text-secondary);letter-spacing:normal;text-transform:none}.t-scrollbar[_ngcontent-%COMP%]{display:flex;padding-bottom:.75rem;box-sizing:border-box;flex:1}.t-floating[_ngcontent-%COMP%], .t-floating[_ngcontent-%COMP%]     .t-tools-wrapper{max-inline-size:var(--tui-floating-toolbar-max-width, 31.25rem);flex-wrap:nowrap}"],
        changeDetection: 0
      });
    }
  }
  return TuiEditor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiEditorPortal = /*#__PURE__*/(() => {
  class TuiEditorPortal extends TuiRectAccessor {
    constructor() {
      super(...arguments);
      this.el = inject(ElementRef).nativeElement;
      this.type = 'viewport';
    }
    getClientRect() {
      return this.el.getBoundingClientRect();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiEditorPortal_BaseFactory;
        return function TuiEditorPortal_Factory(__ngFactoryType__) {
          return (ɵTuiEditorPortal_BaseFactory || (ɵTuiEditorPortal_BaseFactory = i0.ɵɵgetInheritedFactory(TuiEditorPortal)))(__ngFactoryType__ || TuiEditorPortal);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiEditorPortal,
        selectors: [["", "tuiEditorPortal", ""]],
        features: [i0.ɵɵProvidersFeature([{
          provide: TuiDropdownService,
          useExisting: TuiEditorPortalService
        }, tuiAsViewport(TuiEditorPortal)]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiEditorPortal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiEditorPortalHost = /*#__PURE__*/(() => {
  class TuiEditorPortalHost extends TuiPortals {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiEditorPortalHost_BaseFactory;
        return function TuiEditorPortalHost_Factory(__ngFactoryType__) {
          return (ɵTuiEditorPortalHost_BaseFactory || (ɵTuiEditorPortalHost_BaseFactory = i0.ɵɵgetInheritedFactory(TuiEditorPortalHost)))(__ngFactoryType__ || TuiEditorPortalHost);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiEditorPortalHost,
        selectors: [["tui-editor-portal-host"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: TuiPortalService,
          useExisting: TuiDropdownService
        }, {
          provide: TuiPortals,
          useExisting: TuiEditorPortalHost
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 0,
        consts: [["viewContainer", ""]],
        template: function TuiEditorPortalHost_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
          }
        },
        styles: ["[_nghost-%COMP%]{position:absolute;top:0;left:0;display:block;block-size:100%;inline-size:100%;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return TuiEditorPortalHost;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_EDITOR_PROVIDERS, TuiEditor, TuiEditorDropdownToolbar, TuiEditorPortal, TuiEditorPortalHost, TuiEditorPortalService };
